// extracted by mini-css-extract-plugin
export default {"customConfirmBtn":"ChangePasswordPopup_customConfirmBtn__Z7bEv","cancelBtn":"ChangePasswordPopup_cancelBtn__en1rF"};